module.exports = __webpack_public_path__ + "static/media/strong01.78a89b95.jpg";